export default __webpack_public_path__ + "static/media/wedding_3.199124fc.jpg";